import { render, staticRenderFns } from "./MsisdnSummaryField2.vue?vue&type=template&id=026db5f8&"
import script from "./MsisdnSummaryField2.vue?vue&type=script&lang=js&"
export * from "./MsisdnSummaryField2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports